import { render, staticRenderFns } from "./DirTranslationCloud.vue?vue&type=template&id=47c9f222&scoped=true"
import script from "./DirTranslationCloud.vue?vue&type=script&lang=js"
export * from "./DirTranslationCloud.vue?vue&type=script&lang=js"
import style0 from "./DirTranslationCloud.vue?vue&type=style&index=0&id=47c9f222&prod&scoped=true&lang=css"
import style1 from "./DirTranslationCloud.vue?vue&type=style&index=1&id=47c9f222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c9f222",
  null
  
)

export default component.exports